import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const location = useLocation();
  const isEnglish = location.pathname === '/en' || location.pathname.startsWith('/en/');

  const withLocalePath = (path: string) => {
    if (!path || path.startsWith('http') || path.startsWith('#') || path.startsWith('/blog')) {
      return path;
    }
    if (isEnglish && !path.startsWith('/en')) {
      return `/en${path}`;
    }
    return path;
  };

  return (
    <nav className="py-4 px-4 sm:px-6 lg:px-8 bg-metal-dark border-b border-metal">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center space-x-2 text-sm font-['Roboto_Mono']">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="text-metal-light mx-2">＞</span>
              )}
              {item.path ? (
                <Link
                  to={withLocalePath(item.path)}
                  className="text-accent hover:text-white transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-white font-semibold">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
